import { AfterContentInit, Component, ElementRef, EventEmitter, Input, Output, inject } from '@angular/core';
import { Option } from '@cumlaude/shared-utils';

@Component({
	selector: 'app-single-select-list',
	templateUrl: './single-select-list.component.html',
	styleUrls: ['./single-select-list.component.scss'],
})
export class SingleSelectListComponent<T> implements AfterContentInit {
	private readonly elementRef = inject(ElementRef);

	@Input()
	opties: Option<T>[] = [];

	@Input()
	selectedOptie: Option<T> | undefined;

	@Output()
	onOptieClicked = new EventEmitter<T>();

	set value(optie: Option<T>) {
		this.selectedOptie = optie;
	}

	writeValue(obj: T, $event?: Event): void {
		$event?.stopPropagation();

		const newValue = this.opties.find((optie) => optie.value === obj);
		this.value = newValue!;
		this.onOptieClicked.emit(newValue?.value);
	}

	isSelected(optie: Option<T>): boolean {
		return optie.value === this.selectedOptie?.value;
	}

	ngAfterContentInit(): void {
		setTimeout(() => {
			this.elementRef.nativeElement.querySelector('.is-selected')?.scrollIntoView({
				behavior: 'auto',
				block: 'center',
				inline: 'start',
			});
		});
	}
}
